var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"value":_vm.value,"items":_vm.parameters,"chips":"","small-chips":"","item-text":"name","item-value":"number","label":_vm.label},on:{"change":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }